<template>
  <div id="site-login" class="page-bg valign-wrapper">
    <div v-if="$store.getters.platform !== 'browser'" class="wrapper">
      <Login :title="$t('SETTINGS.LOGIN')"/>
    </div>
  </div>
</template>

<script>
import Bus from '@/components/ControlBus'
import Login from '@/components/Login'

export default {
  name: 'SiteLogin',
  components: { Login },
  created: function () {
    if (this.$store.getters.platform === 'browser') {
      this.$router.replace({name: 'login-browser'})
    }
  },
  mounted: function () {
    // keys control
    Bus.$on('key-back', this.keyBack)
  },
  methods: {
    keyBack () { this.$router.go(-1) }
  },
  beforeDestroy: function () {
    Bus.$off('key-back', this.keyBack)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
#site-login
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, .9)) , url('../../assets/images/splash.jpg')

  .wrapper
    margin: auto
    // background-color: rgba(0, 0, 0, 0.85)
    color: #ffffff
    background-color: #fff
    color: #000
    width: 90%;
    padding: 3rem

</style>



// WEBPACK FOOTER //
// src/pages/site/LoginTv.vue